import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import MortgageRateTrends from './MortgageRateTrends.js';
import { FieldConfig } from './MortgageRateTrends.utils.js';
import { STATE_NAMES } from './constants.js';

var _attributes;
var MortgageRatesTrendsBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs,
      pathName = _ref.pathName;
    var _attrs$loanPurpose = attrs.loanPurpose,
      loanPurpose = _attrs$loanPurpose === void 0 ? 'Purchase' : _attrs$loanPurpose,
      _attrs$creditRating = attrs.creditRating,
      creditRating = _attrs$creditRating === void 0 ? '740 or higher' : _attrs$creditRating,
      _attrs$location = attrs.location,
      location = _attrs$location === void 0 ? 'United States' : _attrs$location,
      _attrs$percentDown = attrs.percentDown,
      percentDown = _attrs$percentDown === void 0 ? '20% or higher' : _attrs$percentDown,
      _attrs$timeSpan = attrs.timeSpan,
      timeSpan = _attrs$timeSpan === void 0 ? 365 : _attrs$timeSpan,
      _attrs$Fixed30Year = attrs.Fixed30Year,
      Fixed30Year = _attrs$Fixed30Year === void 0 ? true : _attrs$Fixed30Year,
      _attrs$Fixed20Year = attrs.Fixed20Year,
      Fixed20Year = _attrs$Fixed20Year === void 0 ? false : _attrs$Fixed20Year,
      _attrs$Fixed10Year = attrs.Fixed10Year,
      Fixed10Year = _attrs$Fixed10Year === void 0 ? false : _attrs$Fixed10Year,
      _attrs$Fixed15Year = attrs.Fixed15Year,
      Fixed15Year = _attrs$Fixed15Year === void 0 ? false : _attrs$Fixed15Year,
      _attrs$ARM = attrs.ARM7,
      ARM7 = _attrs$ARM === void 0 ? false : _attrs$ARM,
      _attrs$ARM2 = attrs.ARM5,
      ARM5 = _attrs$ARM2 === void 0 ? false : _attrs$ARM2,
      _attrs$ARM3 = attrs.ARM3,
      ARM3 = _attrs$ARM3 === void 0 ? false : _attrs$ARM3;
    pathName = '/mortgage-rates/';
    var defaultValues = {
      loanPurpose: loanPurpose,
      creditRating: creditRating,
      location: location,
      percentDown: percentDown,
      timeSpan: timeSpan,
      Fixed30Year: Fixed30Year,
      Fixed20Year: Fixed20Year,
      Fixed15Year: Fixed15Year,
      Fixed10Year: Fixed10Year,
      ARM7: ARM7,
      ARM5: ARM5,
      ARM3: ARM3
    };
    var editorMode = isEditor();
    return /*#__PURE__*/React.createElement(MortgageRateTrends, {
      defaultValues: defaultValues,
      editorMode: editorMode,
      pathName: pathName
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/mortgageratetrends',
    title: 'Mortgage Rate Trends',
    description: 'Interactive graph to see historical mortgage rates tailored by loan program, credit score, down payment and location.',
    icon: 'chart-line',
    keywords: ['mortgages', 'rates', 'trends'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Layout',
    attributes: (_attributes = {}, _attributes[FieldConfig.loanPurpose.name] = {
      type: 'string',
      default: 'Purchase',
      label: 'Default loan purpose',
      control: 'select',
      choices: [{
        label: 'Purchase',
        value: 'Purchase'
      }, {
        label: 'Refinance',
        value: 'Refinance'
      }]
    }, _attributes[FieldConfig.creditRating.name] = {
      type: 'string',
      default: '740 or higher',
      label: 'Default credit rating',
      control: 'select',
      choices: [{
        label: '740 or higher',
        value: '740 or higher'
      }, {
        label: '680 - 740',
        value: '680 - 740'
      }, {
        label: 'Less than 680',
        value: 'Less than 680'
      }]
    }, _attributes[FieldConfig.location.name] = {
      type: 'string',
      label: 'Default location',
      default: 'United States',
      control: 'select',
      choices: STATE_NAMES.map(function (label) {
        return {
          label: label,
          value: label
        };
      })
    }, _attributes[FieldConfig.percentDown.name] = {
      type: 'string',
      default: '20% or higher',
      label: 'Default percent down',
      control: 'select',
      choices: [{
        label: '20% or higher',
        value: '20% or higher'
      }, {
        label: '5% - 20%',
        value: '5% - 20%'
      }, {
        label: 'Less than 5%',
        value: 'Less than 5%'
      }]
    }, _attributes[FieldConfig.timeSpan.name] = {
      type: 'number',
      default: 365,
      label: 'Default timespan',
      control: 'select',
      choices: [{
        label: '1 day',
        value: 1
      }, {
        label: '7 days',
        value: 7
      }, {
        label: '1 month',
        value: 30
      }, {
        label: '3 months',
        value: 90
      }, {
        label: '1 year',
        value: 365
      }, {
        label: '2 years',
        value: 730
      }]
    }, _attributes[FieldConfig.Fixed30Year.name] = {
      type: 'boolean',
      label: 'Default 30 year fixed',
      default: true,
      control: 'boolean'
    }, _attributes[FieldConfig.Fixed20Year.name] = {
      type: 'boolean',
      label: 'Default 20 year fixed',
      default: false,
      control: 'boolean'
    }, _attributes[FieldConfig.Fixed15Year.name] = {
      type: 'boolean',
      label: 'Default 15 year fixed',
      default: false,
      control: 'boolean'
    }, _attributes[FieldConfig.Fixed10Year.name] = {
      type: 'boolean',
      label: 'Default 10 year fixed',
      default: false,
      control: 'boolean'
    }, _attributes[FieldConfig.ARM7.name] = {
      type: 'boolean',
      label: 'Default 7-year ARM',
      default: false,
      control: 'boolean'
    }, _attributes[FieldConfig.ARM5.name] = {
      type: 'boolean',
      label: 'Default 5-year ARM',
      default: false,
      control: 'boolean'
    }, _attributes[FieldConfig.ARM3.name] = {
      type: 'boolean',
      label: 'Default 3-year ARM',
      default: false,
      control: 'boolean'
    }, _attributes)
  }
};
var MortgageRatesTrendsBlock$1 = MortgageRatesTrendsBlock;

export { MortgageRatesTrendsBlock$1 as default };
